<template>
  <div class="app-container">
    <div class="header">
      <el-input
        size="medium"
        v-model="search"
        :placeholder="this.$t('file.appfile.searchhint')"
        @keyup.enter.native="FileSearch()"
        class="search"
      />
      <el-button
        icon="el-icon-search"
        @click="FileSearch()"
        type="primary"
        class="btnInsert"
        >{{ $t("file.appfile.searchbtn") }}</el-button
      >

      <el-button
        type="success"
        @click="openInsertFileForm"
        size="mini"
        class="btnInsert"
        v-if="this.PermissionCheck1()"
        >{{ $t("file.appfile.insertbtn") }}</el-button
      >
    </div>

    <el-dialog
      :title="this.$t('file.appfile.uploadtitle')"
      :visible.sync="dialogFormVisible"
      :width="dialogWidth"
      :close-on-click-modal="false"
    >
      <el-form v-loading="updating" element-loading-text="Updating">
        <el-form :model="appform">
          <el-form-item
            :label="this.$t('file.appfile.uploadphone')"
            :label-width="formLabelWidth"
          >
            <el-input v-model="appform.phone" autocomplete="off" @input="change($event)">
            </el-input>
          </el-form-item>
          <el-form-item
            :label="this.$t('file.appfile.uploadapplicationID')"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="appform.applicationID"
              autocomplete="off"
              @input="change($event)"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            :label="this.$t('file.appfile.uploadversionname')"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="appform.versionname"
              autocomplete="off"
              @input="change($event)"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            :label="this.$t('file.appfile.uploadversioncode')"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="appform.versioncode"
              autocomplete="off"
              @input="change($event)"
            >
            </el-input>
          </el-form-item>

          <el-form-item
            :label="this.$t('file.appfile.old_versioncode')"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="appform.old_versioncode"
              autocomplete="off"
              @input="change($event)"
            >
            </el-input>
          </el-form-item>

          <el-form-item
            :label="this.$t('file.appfile.incremental_update')"
            :label-width="formLabelWidth"
          >
            <el-switch
              v-model="incremental_update"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>

          <el-form-item
            v-show="incremental_update"
            :label="this.$t('file.appfile.update_detail')"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="appform.update_detail"
              autocomplete="off"
              @input="change($event)"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </el-form>
      <el-upload
        class="upload-demo"
        drag
        :multiple="false"
        :show-file-list="true"
        :auto-upload="false"
        action="string"
        :on-change="handleFileSelect"
        :on-remove="handleFileRemove"
        accept=".apk"
        >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text" v-html="dragText"></div>
            <div class="el-upload__tip" slot="tip" v-html="uploadTip"></div>
      </el-upload>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancle()" style="margin-right: 5px">{{
          $t("file.appfile.uploadcancel")
        }}</el-button>
      <el-button
        :disabled="isUpload1() && !selectedFile"
        @click="handleManualUpload"
        type="primary"
      >
        {{ $t("file.appfile.uploadupload") }}
      </el-button>
      </div>
    </el-dialog>

    <el-table :data="appList" style="width: 100%">
      <el-table-column label="Id" prop="id" width="100px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="APP ID" prop="applicationId" width="200px">
      </el-table-column>
      <el-table-column label="APP Name" prop="apkName" width="200px">
      </el-table-column>
      </el-table-column>
      <el-table-column label="VersionCode" prop="version" width="200px">
      </el-table-column>
      <el-table-column label="OldVersionCode" prop="oldVersion" width="200px">
      </el-table-column>
      <el-table-column label="UpdateDetail" prop="updateDetail" width="200px">
      </el-table-column>
      <el-table-column label="Phone" prop="phone" width="200px"> </el-table-column>

      <el-table-column label="Create Time" prop="createTime" width="200px">
      </el-table-column>

      <el-table-column label="Operate" prop="" fixed="right">
        <template slot-scope="scope">
          <el-tag type="primary" class="btn">
            <el-link type="success"
            @click="downloadOneFile(scope.row.id, scope.row.filePath)"
            :href="scope.row.filePath">{{
              $t("file.appfile.operatedownload")
            }}</el-link>
          </el-tag>
          <el-tag v-if="PermissionCheck1()" type="danger" class="btn">
            <el-link
              type="danger"
              @click="deleteOneFile(scope.row.id, scope.row.filePath)"
              >{{ $t("file.appfile.operatedelete") }}</el-link
            >
          </el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="length"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      class="pagination"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  computed: {
    dragText() {
      return this.$i18n.locale === 'zh'
        ? '将文件拖到此处，或<em>点击上传</em>'
        : 'Drag the file here, or <em>click to upload</em>';
    },
    uploadTip() {
      return this.$i18n.locale === 'zh'
        ? '只能上传apk文件'
        : 'Only APK files can be uploaded';
    }
  },
  data() {
    return {
      appList: [
        {
          id: "",
          phone: "",
          createTime: "",
          filePath: "",
          apkName: "",
          version: "",
          oldVersion: "",
          updateDetail: "",
          applicationId: "",
        },
      ],
      appform: {
        appUrl: "",
        phone: "",
        versionname: "",
        versioncode: "",
        old_versioncode: "",
        update_detail: "",
        applicationId: "",
      },
      search: "",
      length: 5,
      page: 1,
      total: 0,
      incremental_update: false,
      dialogWidth: "30%",
      dialogTitle: "上传APP文件",
      dialogFormVisible: false,
      formLabelWidth: "120px",
      btnName: "上传",
      updating: false,
      selectedFile: null,
    };
  },
  created() {
    this.reload();
  },
  methods: {
    isUpload1() {
      if (
        this.appform.phone == "" ||
        this.appform.versioncode == "" ||
        this.appform.versionname == "" ||
        this.appform.old_versioncode == "" ||
        this.appform.applicationID == ""
      ) {
        return false;
      }
      return true;
    },
    change(e) {
      this.$forceUpdate();
    },
    cancle() {
      this.dialogFormVisible = false;
      this.reload();
    },
    reload() {
      let that = this;
      let length = that.length;
      let page = that.page;
      that
        .getRequest(
          "/tpa-api/manageFile/getAllAPPFiles?length=" + length + "&page=" + page,
          null
        )
        .then((resp) => {
          if (resp) {
            that.appList = resp.result;
            that.total = resp.total;
          }
        });
    },
    // 分页功能
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.length = val;
      this.reload();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.reload();
    },
    FileSearch() {
      let that = this;
      let adminName = that.search;
      let length = that.length;
      let page = that.page;
      that
        .getRequest(
          "/tpa-api/manageFile/getAllAPPFiles?length=" +
            length +
            "&page=" +
            page +
            "&appName=" +
            adminName,
          null
        )
        .then((resp) => {
          if (resp) {
            that.appList = resp.result;
            that.total = resp.total;
          }
        });
    },
    downloadOneFile(id, filePath){
      let that = this;
      const encodedFilePath = encodeURIComponent(filePath);
      const params = new URLSearchParams({
              apkId: id,
              filePath: encodedFilePath
          });
          const url = "/tpa-api/manageFile/getAPK?apkId=" + id + "&filePath=" + encodeURIComponent(filePath);
          console.log("请求URL:", url);
      that
        .getRequest(
          "/tpa-api/manageFile/getAPK?" + params.toString(),
          null
        )
        .then((resp) => {
          if (resp) {
            that.appList = resp.result;
            that.total = resp.total;
          }
        });
    },
    deleteOneFile(id, filePath) {
      // 跳出确认框
      let that = this;
      that
        .$confirm(this.$t("notification.appfilemessage"), this.$t("notification.title"), {
          confirmButtonText: this.$t("notification.confirm"),
          cancelButtonText: this.$t("notification.cancel"),
          type: "warning",
        })
        .then(() => {
          // 发送ajax请求删除数据
          that
            .deleteRequest(
              "/tpa-api/manageFile/deleteOneAppFile?appId=" + id + "&filePath=" + filePath,
              null
            )
            .then((resp) => {
              if (resp.code == 200) {
                // 重新加载
                that.page = 1;
                that.length = 5;
                that.reload();
              }
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: this.$t("notification.cancelinfo"),
          });
        });
    },
    openInsertFileForm() {
      this.appform = {
        appUrl: "",
        phone: "",
        versionname: "",
        versioncode: "",
        old_versioncode: "",
        update_detail: "",
        applicationId: "",
      };
      this.dialogFormVisible = true;
    },
      handleManualUpload() {
        // 检查是否有选中的文件
        if (!this.selectedFile) {
          this.$message.warning('请先选择一个APK文件');
          return;
        }

        // 构建 FormData (与您原来的 uploadFile 逻辑一致)
        let formData = new FormData();
        formData.append("file", this.selectedFile); // 使用第一个组件选中的文件
        formData.append("applicationID", this.appform.applicationID);
        formData.append("phone", this.appform.phone);
        formData.append("name", this.appform.versionname);
        formData.append("version", this.appform.versioncode);
        formData.append("old_version", this.appform.old_versioncode);
        formData.append("update_detail", this.appform.update_detail);
        formData.append("incremental", this.incremental_update);

        this.updating = true;
        console.log("/tpa-api/manageFile/uploadAPK");
        this.postFormRequest1("/tpa-api/manageFile/uploadAPK", formData)
          .then((resp) => {
            console.log("其他字段:", Object.keys(resp))
            if (resp.code == 200) {
              this.$message.success('上传成功');
              this.reload();
              // 上传成功后，重置状态
              this.selectedFile = null;
              this.dialogFormVisible = false;
              // 可选：清空第一个 upload 组件的文件列表 (需要ref)
              this.$refs.uploadRef.clearFiles();
            }
            else{

            }
          })
          .catch((err) => {
            console.error("上传失败" + err);
            this.$message.error('上传失败,' + err);
          })
          .finally(() => {
            this.updating = false;
          });
      },
    uploadFile(param) {
      let that = this;
      let formData = new FormData();
      formData.append("file", param.file);
      formData.append("phone", that.appform.phone);
      formData.append("name", that.appform.versionname);
      formData.append("version", that.appform.versioncode);
      formData.append("old_version", that.appform.old_versioncode);
      formData.append("update_detail", that.appform.update_detail);
      formData.append("applicationID", that.appform.applicationID);
      this.updating = true;
      that
        .postFormRequest1("/tpa-api/manageFile/uploadAPP", formData)
        .then((resp) => {
          if (resp.code == 200) {
            that.reload();
            that.appform = {
              filePath: "",
              phone: "",
              versionname: "",
              versioncode: "",
              old_versioncode: "",
              update_detail: "",
              applicationID: "",
            };
          }
        })
        .then((resp) => {
          this.updating = false;
          this.dialogFormVisible = false;
        })
        .catch((err) => {
          //处理错误
          this.updating = false;
          this.dialogFormVisible = true;
          console.error(err);
        });
    },
    PermissionCheck1() {
      var userInfo = JSON.parse(window.localStorage.getItem("user"));
      var permission = userInfo.permission;
      console.log("用户权限:", permission);
      if (permission.length === 5) {
        return false;
      } else if (permission.length === 8) {
        return true;
      }
      return false;
    },
    handleFileSelect(file, fileList) {
    this.selectedFile = file.raw; // file.raw 是原生的 File 对象
    },

    handleFileRemove(file, fileList) {
    this.selectedFile = null;
    },
  },
};
</script>
<style scoped>
.avatar {
  height: 50px;
}

.pagination {
  display: flex;
  float: left;
  margin-left: 10px;
  margin-top: 40px;
}

.btnInsert {
  margin-left: 50px;
  height: 36px;
  font-size: 10px;
  line-height: 10px;
  float: right;
}

.search {
  width: 30%;
  height: 50px;
}

.header {
  display: flex;
  flex-direction: row;
}

.btn {
  cursor: pointer;
}

.a1 {
  text-decoration: none;
}

.dialog-footer {
  display: flex;
  float: right;
  margin-top: -30px;
}
</style>
